<template>
    <section class="practice">
           <vue-snotify></vue-snotify>
           <div class="row">
               
               <div id="content" class="content  col-md-12">
                   <div class="material-box bg-white">
                       <div class="col-md-12 top-title">
                           <h3>Edit Profile</h3>
                       </div>
                       <div class="col-md-12">
                           <div class="section-container section-with-top-border p-b-10 ">
                               <form class="form-horizontal fv-form fv-form-bootstrap" @submit.prevent="saveUser" method="post"
                                   enctype="multipart/form-data">
                                   <div class="row">
                                       <div class="col-md-4 col-sm-4">
                                           <div class="form-group">
                                               <label for="FirstName">First Name</label>
                                               <b-input-group>
                                                   <b-input-group-prepend is-text>
                                                       <i class="fa fa-user"></i>
                                                   </b-input-group-prepend>
                                                   <b-form-input type="text" id="FirstName" name="FirstName"
                                                       autocomplete="FirstName" placeholder="First Name"
                                                       v-model="form.FirstName"
                                                       aria-describedby="input-1-live-feedback"
                                                       label="First Name"></b-form-input>
                                                   <b-form-invalid-feedback id="input-1-live-feedback">
                                                       This is a required field.
                                                   </b-form-invalid-feedback>
                                               </b-input-group>
                                           </div>
                                           <div class="form-group">
                                               <label for="LastName">Last Name</label>
                                               <b-input-group>
                                                   <b-input-group-prepend is-text>
                                                       <i class="fa fa-user"></i>
                                                   </b-input-group-prepend>
                                                   <b-form-input type="text" id="LastName" name="LastName"
                                                       autocomplete="LastName" placeholder="Last Name"
                                                       v-model="form.LastName"
                                                       aria-describedby="input-1-live-feedback"
                                                       label="Last Name"></b-form-input>
                                                   <b-form-invalid-feedback id="input-1-live-feedback">
                                                       This is a required field.
                                                   </b-form-invalid-feedback>
                                               </b-input-group>
                                           </div>
                                           <div class="form-group">
                                               <label>User Name</label>
                                               <b-input-group>
                                                   <b-input-group-prepend is-text>
                                                       <i class="fa fa-user"></i>
                                                   </b-input-group-prepend>
                                                   <b-form-input type="text" id="Username" name="Username"
                                                       autocomplete="Username" placeholder="please input login name"
                                                       v-model="form.Username"
                                                       aria-describedby="input-1-live-feedback"
                                                       label="Username"></b-form-input>
                                                   <b-form-invalid-feedback id="input-1-live-feedback">
                                                       This is a required field.
                                                   </b-form-invalid-feedback>
                                               </b-input-group>
                                           </div>
                                           <div class="form-group">
                                               <label for="Email">User Email</label>
                                               <b-input-group prepend="@">
                                                   <b-form-input type="email" id="Email" name="email" autocomplete="Email"
                                                       placeholder="Email" v-model="form.email"
                                                       aria-describedby="input-1-live-feedback"
                                                       label="Email"></b-form-input>
                                                   <b-form-invalid-feedback id="input-1-live-feedback">
                                                       This is a required field.
                                                   </b-form-invalid-feedback>
                                                   <span class="text-danger" v-if="emailErr != ''">{{ emailErr }}</span>
                                               </b-input-group>
                                           </div>
                                           <div class="form-group">
                                               <label for="Status">Practice Name</label>
                                               <b-input-group prepend="@">
                                                   <b-form-input type="text" id="PracticeName" name="PracticeName"
                                                       autocomplete="PracticeName" placeholder=""
                                                       v-model="form.PracticeName"
                                                       aria-describedby="input-1-live-feedback"
                                                       label="PracticeName" readonly="readonly"></b-form-input>
                                                   <b-form-invalid-feedback id="input-1-live-feedback">
                                                       This is a required field.
                                                   </b-form-invalid-feedback>
                                               </b-input-group>
                                           </div>
                                           <div class="form-group">
                                               <label for="City">City</label>
                                               <b-input-group>
                                                   <b-input-group-prepend is-text>
                                                       <i class="fa fa-globe"></i>
                                                   </b-input-group-prepend>
                                                   <b-form-input type="text" id="City" name="City" autocomplete="City"
                                                       v-model="form.City"></b-form-input>
                                               </b-input-group>
                                           </div>
                                           <div class="form-group">
                                               <label for="Zip">Zip</label>
                                               <b-input-group prepend="@">
                                                   <b-form-input type="text" id="Zip" name="Zip" autocomplete="Zip"
                                                       v-model="form.Zip"></b-form-input>
                                               </b-input-group>
                                           </div>
                                           <!-- <div>
                                               <label for="Password">Password</label>
                                               <b-input-group>
                                                   <b-input-group-prepend is-text>
                                                       <i class="fa fa-key"></i>
                                                   </b-input-group-prepend>
                                                   <b-form-input :type="pField" id="password" name="password"
                                                       autocomplete="password" v-model="form.password"
                                                       aria-describedby="input-1-live-feedback"
                                                       placeholder="Enter password For changing"
                                                       ></b-form-input>
                                                   <b-form-invalid-feedback id="input-1-live-feedback">
                                                       This is a required field.
                                                   </b-form-invalid-feedback>
                                               </b-input-group>
                                               <input type="checkbox" @click="showPass">Show the password
                                           </div> -->
                                           <div class="form-group">
                                               <label for="OldPassword">Old Password</label>
                                               <b-input-group>
                                                   <b-input-group-prepend is-text>
                                                   <i class="fa fa-key"></i>
                                                   </b-input-group-prepend>
                                                   <b-form-input
                                                   :type="pField"
                                                   id="old-password"
                                                   name="oldPassword"
                                                   autocomplete="old-password"
                                                   v-model="oldPassword"
                                                   placeholder="Enter old password"
                                                   ></b-form-input>
                                               </b-input-group>
                                           </div>
   
                                           <div class="form-group">
                                               <label for="NewPassword">New Password</label>
                                               <b-input-group>
                                                   <b-input-group-prepend is-text>
                                                   <i class="fa fa-key"></i>
                                                   </b-input-group-prepend>
                                                   <b-form-input
                                                   :type="pField"
                                                   id="new-password"
                                                   name="newPassword"
                                                   autocomplete="new-password"
                                                   v-model="newPassword"
                                                   placeholder="Enter new password"
                                                   ></b-form-input>
                                               </b-input-group>
                                               </div>
                                               <input type="checkbox" @click="showPass">Show the password
                                           <div class="form-group">
                                               <label for="Address1" >Address 1</label>
                                               <div>
                                                   <textarea v-model="form.Address1" style="margin: 0px; width: 100%; height: 70px;" name="Address1"></textarea>
                                               </div>
                                           </div>
                                           
                                           <!-- <div class="row m-4">
                                               <div class="col-md-6 offset-4">
                                                   <img :src="`${$server_url}images/profile/${oldImagePrev}`" alt="Old Image"
                                                       class="img-fluid" />
                                                   <input type="file" ref="fileInput" @change="handleFileUpload" />
                                                   <img v-if="imagePreviewUrl" :src="imagePreviewUrl" alt="Image Preview"
                                                       class="img-fluid" />
                                                   <button v-if="imagePreviewUrl" @click="removeImage">Remove Image</button>
                                               </div>
                                           </div> -->
                                       </div>
                                       <div class="col-md-4 col-sm-4">
                                           <div class="form-group">
                                               <label for="StateID">State ID</label>
                                               <b-input-group>
                                                   <b-input-group-prepend is-text>
                                                       <i class="fa fa-globe"></i>
                                                   </b-input-group-prepend>
                                                   <b-form-select id="StateID" v-model="form.StateID"
                                                       :options="StateOptions" value-field="StateID" text-field="Name">
                                                   </b-form-select>
                                               </b-input-group>
                                           </div>
                                           <div class="form-group">
                                               <label for="Phone1">Phone 1</label>
                                               <b-input-group>
                                                   <b-input-group-prepend is-text>
                                                       <i class="fa fa-phone"></i>
                                                   </b-input-group-prepend>
                                                   <b-form-input type="text" id="Phone1" name="Phone1" autocomplete="Phone1"
                                                       v-model="form.Phone1"></b-form-input>
                                               </b-input-group>
                                           </div>
                                           <div class="form-group">
                                               <label for="Phone2">Phone 2</label>
                                               <b-input-group>
                                                   <b-input-group-prepend is-text>
                                                       <i class="fa fa-phone"></i>
                                                   </b-input-group-prepend>
                                                   <b-form-input type="text" id="Phone2" name="Phone2" autocomplete="Phone2"
                                                       v-model="form.Phone2"></b-form-input>
                                               </b-input-group>
                                           </div>
                                           <div class="form-group">
                                               <label for="Fax">Fax</label>
                                               <b-input-group>
                                                   <b-input-group-prepend is-text>
                                                       <i class="fa fa-fax"></i>
                                                   </b-input-group-prepend>
                                                   <b-form-input type="text" id="Fax" name="Fax" autocomplete="Fax"
                                                       v-model="form.Fax"></b-form-input>
                                               </b-input-group>
                                           </div>
                                           <div class="form-group">
                                               <label for="Prefix">Prefix</label>
                                               <b-input-group prepend="@">
                                                   <b-form-input type="text" id="Prefix" name="Prefix" autocomplete="Prefix"
                                                       v-model="form.Prefix"></b-form-input>
                                               </b-input-group>
                                               <!-- <b-input-group prepend="@">
                                                   <b-form-select id="Prefix" v-model="form.Prefix"
                                                       :options="PrefixOptions" value-field="item"
                                                       text-field="item">
                                                   </b-form-select>
                                                   <b-form-invalid-feedback id="input-1-live-feedback">
                                                       This is a required field.
                                                   </b-form-invalid-feedback>
                                               </b-input-group> -->
                                           </div>
                                           <div class="form-group">
                                               <label for="Status">Status</label>
                                               <b-input-group prepend="@">
                                                   <b-form-input type="text" id="Status" name="Status" autocomplete="Status"
                                                       v-model="form.Status" readonly="readonly"></b-form-input>
                                               </b-input-group>
                                           </div>
                                           <div class="form-group">
                                               <label for="Address2">Address 2</label>
                                               <b-input-group prepend="@">
                                                   <b-form-input type="text" id="Address2" name="Address2" autocomplete="Address2"
                                                       v-model="form.Address2"></b-form-input>
                                               </b-input-group>
                                           </div>
                                       </div>
                                       <div class="col-md-4 col-sm-4">
                                            <div class="form-group">
                                                <img :src="form.url" alt="No Preview" width="150" height="150" class="m-b-10">
                                                <br>
                                                <input id="input-4" name="image" @change="onFileSelected($event)" type="file"  class="file-loading">
                                            </div>
                                       </div>
                                       <div class="col-md-12">
                                            <div class="form-group">
                                               <b-button type="submit" variant="success"
                                                   class="btn btn-blue">
                                                 <span>Edit Profile</span>
                                               </b-button>
                                           </div>
                                       </div>
                                   </div>
                               </form>
                           </div>
                       </div>
                   </div>
               </div>
           </div>
       </section>
   </template>
   
   <script>
   import moment from 'moment'
   import userAPI from './userApi'
   import { validationMixin } from "vuelidate";
   import { required, email } from "vuelidate/lib/validators";
   import practiceSidebar from "./Practice/components/Sidebar.vue";
   import globalVar from "./../Config/config";

   var server_url = globalVar.server_url;


   
   export default {
       name: "view_user",
       components: {
        // practiceSidebar,

       },
       data() {
           return {
               users: [],
               oldPassword: '',
               newPassword: '',
               oldImagePrev: '',
               pField: "password",
               loginUser: {},
               emailErr: "",
               imagePreviewUrl: '',
               StateOptions: [],
               pages: [
                   'SeminarPackingItems',
                   'Members',
                   'Seminars',
                   'Webinar',
                   'EmailMarketing',
                   'Referrals',
                   'Modules',
                   'Documents',
                   'Videos',
                   'Webcontent'
               ],
               allowedPages: [],
               form: {
                   id:'',
                   FirstName: "",
                   LastName: "",
                   Username: "",
                   PracticeName: "",
                   Prefix: "",
                   Status: "",
                   password: "",
                   email: "",
                   StateID: "",
                   Fax: "",
                   Phone2: "",
                   Phone1: "",
                   City: "",
                   Address1: "",
                   Address2: "",
                   Admin: 0,
                   url: "",
               },
               server_url: '',
               practiceData:[],
               StatusOptions: [
                   { item: 'DC' },
                   { item: 'CA' },
               ],
               PrefixOptions: [
                   { item: "Dr." },
                   { item: "Mr." },
                   { item: "Mrs." },
                   { item: "Ms." },
               ]
           }
       },
       validations: {
           form: {
               FirstName: {
                   required,
               },
               email: {
                   required, email
               },
               LastName: {
                   required,
               },
               Status: {
                   required,
               },
               Prefix: {
                   required
               }
           }
       },
       methods: {
           getStates() {
               userAPI.getStates(res => {
                   this.StateOptions = res.data.data;
               }, err => {
                   console.log(err);
               })
           },
           getPractice() {
               userAPI.getPracticeById({ PracticeID: this.loginUser.PracticeID }, res => {
                   this.practiceData = res.data.data;
                   console.log(' this.practiceData :',  this.practiceData);
               }, err => {
                   console.log(err);
               });
           },
           limitedAdmin(event) {
               this.form.Admin = event.target.checked ? 1 : 0;
           },
           allowPageFn() {
               this.form.allowedPages = this.allowedPages.join(",");
           },
           pageLabel(allow) {
               return allow;
           },
           onFileSelected(event) {
               // const file = event.target.files[0];
               // this.form.url = file;
               // console.log('this.form.url :', this.form.url);
               // this.form.image = URL.createObjectURL(file);
               // console.log('this.form.image :', this.form.image);
               this.form.image = event.target.files[0];
               this.form.url = URL.createObjectURL(this.form.image);
           },
   
           showPass() {
               this.pField = this.pField == 'password' ? 'text' : 'password';
           },
           removeImage() {
               this.imagePreviewUrl = '';
               this.form.Image = null;
               this.$refs.fileInput.value = '';
           },
           saveUser() {
               const fd = new FormData();
                   if (this.form.image !== undefined && this.form.image instanceof File) {
                       fd.append('image', this.form.image, this.form.image.name)
                   } else {
                       fd.append('image', this.form.image)
                   }
       
                   fd.append('id', this.form.id);
                   fd.append('FirstName', this.form.FirstName);
                   fd.append('LastName', this.form.LastName);
                   fd.append('Username', this.form.Username);
                   fd.append('email', this.form.email);
                   // fd.append('PracticeName', this.form.PracticeName);
                   fd.append('City', this.form.City);
                   fd.append('Zip', this.form.Zip);
                   // fd.append('password', this.form.password);
                   fd.append('Address1', this.form.Address1);
                   fd.append('Address2', this.form.Address2);
                   fd.append('StateID', this.form.StateID);
                   fd.append('Phone1', this.form.Phone1);
                   fd.append('Phone2', this.form.Phone2);
                   fd.append('Fax', this.form.Fax);
                   fd.append('Prefix', this.form.Prefix);
                   fd.append('Status', this.form.Status);
                   fd.append('UserID', this.loginUser.userID);
                   fd.append('oldPassword', this.oldPassword);
                   fd.append('newPassword', this.newPassword);
                   
               userAPI.updateUserProfileInfo( fd,{ UserID: this.loginUser.userID },
                   res => { 
                       this.$showNotification({message:"Updated Successfully"}, "success")
                   }, err => {
                       if (err.response.status == 410) {
                           this.emailErr = err.response.data.message.Email[0];
                       }
                   })
           },
           getUsersDashboard() {
               userAPI.getUsersDashboard({ PracticeID: this.loginUser.PracticeID, active: 1 }, res => {
                   this.users = res.data.data;
               }, err => {
                   console.log(err);
               })
           },
           viewUser(user) {
               this.$router.push({ name: 'single_user', params: { user: user } })
           },
           editUser(user) {
               this.$router.push({ name: 'edit_dashboard_user', params: { user: user } })
           },
           dateFormat(date) {
               return moment(date).format('MM-DD-Y')
           },
           getPastUsersDashboard() {
               userAPI.getUsersDashboard({ PracticeID: this.loginUser.PracticeID, active: 0 }, res => {
                   this.pastUsers = res.data.data;
               }, err => {
                   console.log(err);
               })
           },
           getUserProfileInfo() {
               userAPI.getUserinfo({ UserID: this.loginUser.userID },
                   res => {
                       this.form.FirstName = res.data.data.FirstName;
                       this.form.LastName = res.data.data.LastName;
                       this.form.Username = res.data.data.Username;
                       this.form.email = res.data.data.Email;
                       this.form.PracticeName = res.data.data.PracticeName;
                       this.form.City = res.data.data.City;
                       this.form.Zip = res.data.data.Zip;
                       this.form.password = res.data.data.Password;
                       console.log('this.form.password :',  this.form.password);
                       this.form.Address1 = res.data.data.Address1;
                       this.form.StateID = res.data.data.StateID;
                       this.form.Phone1 = res.data.data.Phone1;
                       this.form.Phone2 = res.data.data.Phone2;
                       this.form.Fax = res.data.data.Fax;
                       this.form.Prefix = res.data.data.Prefix;
                       this.form.Status = res.data.data.Status;
                       this.form.Address2 = res.data.data.Address2;
                       this.form.url = server_url +"images/profile/"+ res.data.data.Image;
                       console.log('this.form.url :', this.form.url);
                       this.users = res.data.data;
                   }, err => {
                       console.log(err);
                   })
           },
       },
       mounted() {
           let user = JSON.parse(localStorage.getItem('userDetails'));
           this.loginUser = user;
   
        //    if (user.Status == 'DC' || user.Status == 'CA') {
        //        this.$router.push({ name: 'user_dashboard' });
        //    }
   
           if (this.$route.params.user) {
               if (this.$route.params.user.allowedPages) {
                   this.allowedPages = this.$route.params.user.allowedPages.split(',');
               }
               this.form = this.$route.params.user;
               this.oldImagePrev = this.$route.params.user.Image;
               this.form.Password = '';
           } 
           this.getStates();
           this.getPractice();
           this.getUserProfileInfo();
       },
   }
   
   </script>

<style>
.form-group .input-group {
    flex-wrap: nowrap;
}
</style>
